

import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import expertimage  from '../../../images/footerLinksImages/featuresimage/expert.jpg'
function ExpertTranner() {

    const keywords = [
        { title: "Experienced Educators", summary: "Learn from seasoned educators who bring years of teaching expertise and practical knowledge to the classroom, ensuring quality education." },
        { title: "Industry Leaders", summary: "Gain insights from industry leaders who share real-world experiences and expertise to help you stay ahead in your career." },
        { title: "Certified Trainers", summary: "Access training from certified professionals who specialize in various fields, ensuring you receive high-quality instruction and skill development." },
        { title: "Hands-On Learning from Experts", summary: "Benefit from practical, hands-on learning experiences guided by industry professionals, enhancing your real-world problem-solving skills." },
        { title: "Mentorship Programs", summary: "Engage in mentorship opportunities with industry professionals who can provide personalized guidance and career advice." },
        { title: "Guest Speakers & Workshops", summary: "Attend exclusive workshops and guest speaker sessions led by experts from various industries, gaining knowledge of the latest trends and practices." },
        { title: "Expert-Led Curriculum", summary: "Study a curriculum designed by experts with deep industry knowledge, ensuring that the content is relevant and aligned with current industry needs." },
        { title: "Professional Network Access", summary: "Connect with a professional network of trainers, mentors, and industry professionals, enhancing your career opportunities." },
        { title: "Updated Industry Practices", summary: "Stay updated on the latest industry trends and practices as trainers and professionals integrate current knowledge into their teaching." },
        { title: "Real-World Insights", summary: "Receive valuable real-world insights directly from industry professionals, ensuring you are well-prepared for challenges in your field." },
      ];
      
    return (<>
        <Header />
       
        <BannerFooter
            title="Expert Trainers & Industry Professionals"
            text="Our team of expert trainers and industry professionals brings real-world experience and in-depth knowledge to every course. We understand the demands of the industry and provide hands-on, practical training that prepares students for success in their careers. With years of experience in their respective fields, our trainers are dedicated to delivering top-notch education, combining theoretical knowledge with practical insights. Whether you're looking to upskill, advance your career, or gain industry-specific expertise, our professionals are here to guide you every step of the way, ensuring you receive the best education possible."
            imageone={expertimage}
            imagetwo={expertimage}
        />

<div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Expert Trainers & Industry Professionals</h2>
    <div className="accordion" id="expertTrainersAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#expertTrainersAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default ExpertTranner